import React from 'react';
import { useFormikContext } from 'formik';
import ValidatedField from 'components/controls/validated-field';
import { parseDate } from 'utils/date-utils';

function DosemeterMeasurementPeriodEndField(props) {
    const {
        values: { measurementPeriodStart },
        touched,
        setFieldValue,
    } = useFormikContext();

    React.useEffect(() => {
        // set period end based on period start
        if (touched.measurementPeriodStart && measurementPeriodStart.trim().length === 10) {
            var startDate = parseDate(measurementPeriodStart);
            var endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 3, startDate.getDate());
            setFieldValue(props.name, endDate.toISOString().slice(0,10));
        }
    }, [measurementPeriodStart, touched.measurementPeriodStart, setFieldValue, props.name]);

    return (
        <ValidatedField {...props} />
    );
};

export default DosemeterMeasurementPeriodEndField;